module.exports = __webpack_public_path__ + "img/yao.0ef910cd.png";